import { render, staticRenderFns } from "./InstitutionDetail.vue?vue&type=template&id=1af4e93c"
import script from "./InstitutionDetail.vue?vue&type=script&lang=js"
export * from "./InstitutionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports